// src/modules/walkInCase/routes.jsx
import { Routes, Route } from 'react-router-dom';
import WalkInCaseList from './pages/WalkInCaseList';
import WalkInCaseForm from './pages/WalkInCaseForm';
import WalkInCaseDetails from './pages/WalkInCaseDetails';

function WalkInCaseRoutes() {
  return (
    <Routes>
      <Route path="/" element={<WalkInCaseList />} />
      <Route path="/create" element={<WalkInCaseForm />} />
      <Route path="/edit/:id" element={<WalkInCaseForm />} />
      <Route path="/:id" element={<WalkInCaseDetails />} />
    </Routes>
  );
}

export default WalkInCaseRoutes;
